import { render } from "./MyPagination.vue?vue&type=template&id=22c35c45&scoped=true"
import script from "./MyPagination.vue?vue&type=script&lang=js"
export * from "./MyPagination.vue?vue&type=script&lang=js"

import "./MyPagination.vue?vue&type=style&index=0&id=22c35c45&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c35c45"]])

export default __exports__